import {
  differenceInWeeks,
  formatDistanceToNowStrict,
  intervalToDuration
} from "date-fns";
import { WeightMeasureEnum } from "requests";
import { KG_TO_LBS } from "../../../duck";

export const getTabs = (
  allTabs: boolean,
  hasDentalCharting: boolean,
  hasTplo: boolean
) => ({
  "check-in": {
    id: 0,
    to: "check-in",
    name: "Check-in"
  },
  ...(allTabs
    ? {
        exam: {
          id: 1,
          to: "exam",
          name: "Exam"
        },
        calculations: {
          id: 2,
          to: "calculations",
          name: "Calculations"
        },
        monitoring: {
          id: 3,
          to: "monitoring",
          name: "Monitoring"
        },
        prescriptions: {
          id: 4,
          to: "prescriptions",
          name: "Prescriptions"
        },
        ...(hasTplo
          ? {
              tplo: {
                id: 5,
                to: "tplo",
                name: "TPLO"
              }
            }
          : {}),
        ...(hasDentalCharting
          ? {
              "dental-charting": {
                id: hasTplo ? 6 : 5,
                to: "dental-charting",
                name: "Dental Charting"
              }
            }
          : {})
      }
    : {})
});

export const getWeight = (
  weightInKg: number | null,
  measure: WeightMeasureEnum
): string => {
  if (weightInKg === null) {
    return "-";
  }

  const weight: Record<WeightMeasureEnum, number> = {
    [WeightMeasureEnum.Lbs]: +(weightInKg * KG_TO_LBS).toFixed(2),
    [WeightMeasureEnum.Kg]: weightInKg,
    [WeightMeasureEnum.G]: +(weightInKg * 1000).toFixed(3)
  };

  return `${weight[measure]} ${measure}`;
};

export const getAge = (dateOfBirth: Date | null): string => {
  if (!dateOfBirth) {
    return "-";
  }

  const duration = intervalToDuration({ start: dateOfBirth, end: new Date() });

  const months = duration.months || 0;
  const days = duration.days || 0;

  if (duration.years === 0 && months === 0 && days < 14) {
    return "1 week";
  }

  if (duration.years === 0 && months < 2) {
    return `${differenceInWeeks(new Date(), dateOfBirth)} weeks`;
  }

  return formatDistanceToNowStrict(dateOfBirth);
};
